import { motion } from "framer-motion";
import { sellerHeader } from "../animation/RoutesAnimations";
import SellerStepper from "../pages/seller-stepper/SellerStepper";
import HeaderLanding from "../components/header/HeaderLanding";
import { Helmet } from "react-helmet";

const SellerLayout = ({
  formNo,
  setFormNo,
  enteredUser,
  setEnteredUser,
  newPageRef2,
}: any) => {
  return (
    <>
      <motion.div
        variants={sellerHeader}
        initial="initial"
        animate="final"
        className=" h-screen overflow-x-hidden overflow-y-auto"
      >
        <Helmet>
          <title>ثبت نام فروشنده وامسی</title>
          <meta name="description" content="ثبت نام فروشنده وامسی" />
          <link rel="canonical" href="https://vam30.com/fa/seller-auth" />
        </Helmet>

        <div className="md:block mb-12 sticky top-0 z-50 bg-white">
          <HeaderLanding
            enteredUser={enteredUser}
            setEnteredUser={setEnteredUser}
            newPageRef2={newPageRef2}
          />
        </div>

        <SellerStepper formNo={formNo} setFormNo={setFormNo} />
      </motion.div>
    </>
  );
};

export default SellerLayout;
